<template>
  <UiModal ref="modal" width="380px" :title="$t('language.set')" :before-cancel="cancel">
    <div class="flex flex-col p-1 text-sm text-neutral-600 dark:text-neutral-300">
      <div
        v-for="lang in systemStore.availableLangs" :key="lang.value"
        class="ls-item border border-solid border-neutral-300 mb-1"
        tabindex="0"
        @click="systemStore.setLanguage(lang.value)"
      >
        <div v-if="lang.value === systemStore.clientSettings.lang" class="absolute right-2 flex items-center justify-center p-1 top-1/2 -translate-y-1/2 bg-emerald-200 rounded-full">
          <UiIcon icon="check" class="text-emerald-600" />
        </div>
        <component :is="getFlag(lang.value)" class="w-6 h-6 mr-2" />
        {{ lang.label }}
      </div>
    </div>
  </UiModal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useSystemStore } from '@/stores'

import UiIcon from '@/components/ui/icon.vue'
import UiModal from '@/components/ui/modal.vue'

import pt from '@/components/ui/icons/flagBrazil.vue'
import en from '@/components/ui/icons/flagUnitedKingdom.vue'
import es from '@/components/ui/icons/flagSpain.vue'

defineProps<{
  text?: string
  asModal?: boolean
}>()

const systemStore = useSystemStore()
const originalLang = ref(systemStore.clientSettings.lang)

const modal = ref<InstanceType<typeof UiModal>>()
  const getFlag = (lang: string) => {
  switch (lang) {
    case 'pt':
      return pt
    case 'en':
      return en
    case 'es':
      return es
    default:
      return pt
  }
}

const open = () => {
  originalLang.value = systemStore.clientSettings.lang
  modal.value.open()
}

const cancel = () => {
  systemStore.setLanguage(originalLang.value)
}

defineExpose({
  open,
  cancel
})
</script>

<style lang="postcss" scoped>
.ls-item {
  @apply relative inline-flex items-center p-3 hover:bg-[--c-primary-300] dark:hover:bg-[--c-primary-700] hover:text-[--c-primary-700] dark:hover:text-[--c-primary-300] rounded transition-all cursor-pointer;
}
</style>